import { useState } from "react"

// Card Component
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
//icons
import PersonOffIcon from "@mui/icons-material/PersonOff"
// componentes
import { formatMoney } from "#common/Funciones"
import ButtonIcon from "#common/buttons/ButtonIcon"
import { TextCampoValor } from "#common/text/CampoValor"
import { MODULES } from "#constants/modules"
import FondoFijoFormulario from "Components/FondoFijo/formulario/FondoFijoFormulario"
import { useHasModuleAccess } from "app/userSlice"
import { useMiEquipoContext } from "./MiEquipoContext"
import DialogSolicitudBaja from "./DialogSolicitudBaja"
// import DialogSolicitudBaja from "../DialogSolicitudBaja"
// import { useMiEquipoContext } from "./MiEquipoContext"

const MiEquipoCardColaborador = ({ colaborador }) => {
	const {
		area,
		photo,
		sucursal,
		perfil_puesto,
		nombre_completo,
		telefono_lubtrac: celular,
		promotion_in_progress,
		no_empleado,
	} = colaborador

	const fields = {
		"No. Empleado": no_empleado,
		"Perfil Puesto": perfil_puesto,
		Departamento: area,
		Sucursal: sucursal,
		// "Fondo Fijo": fondo_fijo,
		"Teléfono Empresa": celular,
	}

	let fields_view = []
	for (const property in fields) {
		fields_view.push(
			<TextCampoValor
				key={property}
				field={property}
				value={fields[property]}
				color="text.secondary"
			/>,
		)
	}

	return (
		<Card
			sx={{
				minWidth: 400,
				width: "100%",
				height: "100%",
				display: "flex",
			}}
		>
			<CardMedia
				component="img"
				sx={{ width: 100 }}
				image={photo}
				alt="Colaborador"
				onError={(e) => {
					e.target.onerror = null
					e.target.src =
						"https://imagenespublicas.s3.us-east-2.amazonaws.com/usuario.webp"
				}}
			/>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					width: "100%",
					height: "100%",
					justifyContent: "space-between", // Este estilo asegura que el contenido esté alineado
				}}
			>
				<Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
					<CardContent>
						<Typography
							gutterBottom
							variant="h6"
							component="div"
							color="text.secondary"
						>
							{nombre_completo}
						</Typography>

						{fields_view}
						{promotion_in_progress && (
							<Typography
								whiteSpace="pre-line"
								variant="body1"
								color="text.secondary"
							>
								<strong>{`Se encuentra en proceso de promoción`}</strong>
							</Typography>
						)}

						<FondoFijoView colaborador={colaborador} />
					</CardContent>
				</Box>
				<CardActions>
					<Stack
						direction={"row"}
						spacing={2}
					>
						<ButtonBaja colaborador={colaborador} />
					</Stack>
				</CardActions>
			</Box>
		</Card>
	)
}
export default MiEquipoCardColaborador

const FondoFijoView = ({ colaborador }) => {
	const { actualizarNow } = useMiEquipoContext()
	const { fondo_fijo, fondo_in_progress, currency_symbol = "$" } = colaborador
	const [openFondo, setOpenFondo] = useState(false)
	const viewFondo = useHasModuleAccess(MODULES.FONDO_FIJO)
	if (!viewFondo) return null
	let buttonText = fondo_in_progress ? "fondo fijo en proceso " : "Solicitar Fondo Fijo"
	let buttonTextEdit = fondo_in_progress ? "fondo fijo en proceso " : "Editar"

	const ButtonFondo = ({ label }) => {
		return (
			<>
				<Button
					size="small"
					sx={{ height: 20 }}
					disabled={fondo_in_progress}
					onClick={() => setOpenFondo(true)}
				>
					{label}
				</Button>
				<FondoFijoFormulario
					open={openFondo}
					setOpen={setOpenFondo}
					actualizar={actualizarNow}
					colaborador={colaborador.id || null}
				/>
			</>
		)
	}

	if (fondo_fijo == null)
		return (
			<Box>
				<ButtonFondo label={buttonText} />
			</Box>
		)
	else
		return (
			<Stack
				direction={"row"}
				spacing={1}
			>
				<TextCampoValor
					field="Fondo fijo"
					value={formatMoney(fondo_fijo, currency_symbol)}
					color="text.secondary"
				/>
				<ButtonFondo label={buttonTextEdit} />
			</Stack>
		)
}

const ButtonBaja = ({ colaborador }) => {
	const { actualizarNow } = useMiEquipoContext()
	const [openSolicitudBaja, setOpenSolicitudBaja] = useState(false)
	const viewBajas = useHasModuleAccess(MODULES.BAJAS)
	if (!viewBajas) return null

	return (
		<>
			<ButtonIcon
				disabled={colaborador.baja_in_progress}
				title="Dar de baja"
				icon={<PersonOffIcon />}
				size="small"
				color="primary"
				onClick={() => setOpenSolicitudBaja(true)}
			/>

			<DialogSolicitudBaja
				open={openSolicitudBaja}
				setOpen={setOpenSolicitudBaja}
				colaborador={colaborador}
				reload={actualizarNow}
			/>
		</>
	)
}
